import styled from 'styled-components';

export const iframe= styled.iframe`
   &.hide{
        width: 0;
        height: 0;
   }
   &.whatsapp-mobile{
        @media screen and (max-width: 1000px){
            height: calc(100% - 60px) !important;
        }
   }
`;
